import { Card, CardContent, CardHeader, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import axios from 'src/utils/axios';
import { text } from '../../modules/languages/index';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
    minHeight: 430,
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  divider: {
    backgroundColor: '#FF9800'
  },
}));


function Answers({ className, FisNo }) {
  const classes = useStyles();
  const [customerAnswers, getCustomerAnswers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    let isMounted = true;
    if (!FisNo) {
      return;
    }
    axios.get(`getTekSeferdeMontajCevaplar/${FisNo}`)
      .then(response => {
        if (!isMounted) return;
        getCustomerAnswers(response.data)
        setIsLoading(false);
      }).catch(error => {
        if (!isMounted) return;
        setIsLoading(false);
              logger.error("Hata detayı:", error.message);
      });

    return () => {
      isMounted = false;
    };
  }, [FisNo]);

  const GetSoru = ({ soru }) => {
    const html = soru
    return (
      <>
        {ReactHtmlParser(html)}
      </>
    );
  }

  return (
    <div>
      <div className={clsx(classes.root, className)}>
        <Card>
          <CardHeader title={text("Montaj_Uygunluk")} />

          <Divider />
          {
            isLoading ?
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }}
              />
              : <div></div>
          }
          {<CardContent className={classes.content}>
            <List className={classes.root}>
              {customerAnswers && customerAnswers.map(log => (
                <div key={log.ID}>
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <div>
                        <Typography
                          component="span"
                          variant="h3"
                          className={classes.inline}
                          color="textPrimary">
                          {log.GUN}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{log.AY.substring(0, 3)}
                        </Typography>
                        <br />
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className={classes.inline}
                          color="textPrimary">{log.YIL}
                        </Typography>
                        <br></br>
                        <Typography
                          component="span"
                          variant="caption"
                          className={classes.inline}
                          color="textPrimary">{log.SAAT}
                        </Typography>
                      </div>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <GetSoru soru={log.SORU} />
                      }
                      // primary={<div>
                      //   {log.SORU.replace(/<\/?[^>]+(>|$)/g, '')}
                      // </div>}
                      //{<div dangerouslySetInnerHTML={{ __html: log.SORU }} />}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            <b>Cevap: {log.CEVAP}</b>
                          </Typography>
                          <br></br>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider className={classes.divider} />
                </div>
              ))}
            </List>
          </CardContent>}

        </Card>

      </div>
    </div>
  );
}

Answers.propTypes = {
  className: PropTypes.string
};


export default Answers;
